module.exports = __webpack_public_path__ + "img/TT.e3e1929d.svg";